import {
   ADD_ISSUE,
   UPDATE_ISSUE,
   GET_ISSUES,
   GET_ISSUE,
   DELETE_ISSUE,
   CLEAR_ISSUE,
   SET_LOADING,
   GET_ISSUE_DOCUMENT,
} from '../types';

const initialState = {
   list: [],
   single: null,
   totalCount: 0,
   isLoading: false,
   pagination: {
      limit: 10,
      nextPage: null,
      totalPages: 1,
      currentPage: 1,
      hasNextPage: false,
      previousPage: null,
      totalProducts: 0,
      hasPreviousPage: false,
   },
   prevAndNext: null,
   issueDocument: [],
};

const issueReducer = (state = initialState, { type, payload }) => {
   switch (type) {
      case GET_ISSUES:
         return {
            ...state,
            list: payload.data,
            totalCount: payload.totalCount,
            pagination: payload.pagination,
            isLoading: false,
         };

      case GET_ISSUE_DOCUMENT:
         return {
            ...state,
            issueDocument: payload.data,
            isLoading: false,
         };

      case GET_ISSUE:
         return {
            ...state,
            single: payload,
            isLoading: false,
         };

      case ADD_ISSUE:
         return {
            ...state,
            list: [payload, ...state.list],
            totalCount: state.totalCount + 1,
            isLoading: false,
         };

      case UPDATE_ISSUE:
         return {
            ...state,
            list: state.list.map((item) => (item.id === payload.id ? payload : item)),
            isLoading: false,
         };

      case DELETE_ISSUE:
         return {
            ...state,
            list: state.list.filter((item) => item.id !== payload.id),
            totalCount: state.totalCount - 1,
            isLoading: false,
         };

      case CLEAR_ISSUE:
         return {
            ...state,
            single: null,
            isLoading: false,
         };

      case SET_LOADING:
         return {
            ...state,
            isLoading: payload,
         };

      default:
         return state;
   }
};

export default issueReducer;
